import { render, staticRenderFns } from "./FndRestQuery.vue?vue&type=template&id=88e2010e&"
import script from "./FndRestQuery.vue?vue&type=script&lang=js&"
export * from "./FndRestQuery.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports